"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOG10EDependencies = void 0;
var _dependenciesBigNumberClassGenerated = require("./dependenciesBigNumberClass.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var LOG10EDependencies = exports.LOG10EDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated.BigNumberDependencies,
  createLOG10E: _factoriesAny.createLOG10E
};